import React, { FC, useRef, useState } from 'react';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import './style.scss';

interface Props {
  data: any;
}

const HomeTaxData: FC<Props> = ({ data }) => {
  const setData = data;
  const clickEvt = (e: any) => {
    console.log('CLICK!');
  };
  return (
    <div className="_step_d_admin_adddoc_data">
      <div className="_content">
        <DefaultButton
          text="서류 추가하기"
          clickEvent={e => clickEvt(e)}
          icon="ri-file-text-line"
          iconStyleDef={{ fontSize: '15px', paddingTop: '0px' }}
          type="type5"
          styleDef={{ height: '34px', fontSize: '13px', width: '180px' }}
        />
      </div>
    </div>
  );
};

export default HomeTaxData;
